import { getAuthData } from "../auth/session.js";

export async function registrationRequest(operation, signal, body = {}) {
  const initData = getAuthData();
  if (!initData) throw new Error("Войдите в аккаунт, чтобы участвовать.");
  let response;
  try {
    response = await fetch(`/api/king-of-the-hill/${operation}`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...body, initData }), signal,
    });
  } catch (error) {
    if (error.name === "AbortError") throw error;
    throw new Error("Нет связи с сервером. Проверьте подключение и попробуйте ещё раз.");
  }
  let data;
  try { data = await response.json(); } catch { data = null; }
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) throw new Error("Сессия истекла. Войдите в аккаунт заново.");
    if (response.status === 404 || response.status === 405) throw new Error("Сервер регистрации недоступен. Возможно, требуется обновление сервера.");
    throw new Error(typeof data?.error === "string" && data.error.trim() ? data.error : "Сервер регистрации временно недоступен.");
  }
  if (!data || !["upcoming", "open", "closed"].includes(data.phase)
    || typeof data.registered !== "boolean" || !Number.isSafeInteger(data.participants) || data.participants < 0) {
    throw new Error("Сервер вернул неполные данные регистрации. Попробуйте позже.");
  }
  return data;
}
